// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getRgaSubtypes} from '../../shared/repositories';
import {readAllPartRequests} from '../../all-parts-requests/action-creators/all-part-requests';

export const getRequestTypes = () =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const allowedTypes = await getRgaSubtypes();

            dispatch({
                allowedTypes,
                type: actions.UPDATE_ALL_PART_REQUESTS_ALLOWED_REQUEST_TYPES
            });

            if (getState().partReturns.allPartReturns.facets.dealerAccountsFacet.isInitialLoad) {

                dispatch({
                    requestTypes: allowedTypes,
                    type: actions.UPDATE_ALL_PART_REQUESTS_SELECTED_REQUEST_TYPES
                });

                dispatch({
                    type: actions.UPDATE_ALL_PART_REQUESTS_IS_INITIAL_LOAD
                });

            }

            readAllPartRequests(getState().partReturns.allPartReturns.facets)(dispatch, getState);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetAllFacets = (defaultDealerAccounts, defaultStatuses, numberOfDays, allowedRequestTypes) => ({
    allowedRequestTypes,
    defaultDealerAccounts,
    defaultStatuses,
    numberOfDays,
    type: actions.RESET_ALL_PART_REQUESTS_FILTERS
});

export const selectAllDealersOnInitialLoad = allowedDealers =>

    dispatch =>

        dispatch({
            allowedDealers,
            type: actions.SELECT_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS
        });

export const selectAllReturnStatusesOnInitialLoad = allowedStatuses =>

    dispatch =>

        dispatch({
            allowedStatuses,
            type: actions.SELECT_ALL_PART_REQUESTS_RETURN_STATUS_FACET_ITEMS
        });

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEM
});

export const updateReturnStatusFacetItem = (returnStatus, isSelected) => ({
    isSelected,
    returnStatus,
    type: actions.UPDATE_ALL_PART_REQUESTS_RETURN_STATUS_FACET_ITEM
});

export const toggleReturnStatusFacetItems = allowedStatuses => ({
    allowedStatuses,
    type: actions.TOGGLE_ALL_PART_REQUESTS_RETURN_STATUS_FACET_ITEMS
});

export const updateAllPartRequestsDateRangeFacet = dateRange => ({
    dateRange,
    type: actions.UPDATE_ALL_PART_REQUESTS_REQUEST_DATE_RANGE_FACET
});

export const selectDefaultLoadRequestDates = numberOfDays =>

    dispatch =>

        dispatch({
            numberOfDays,
            type: actions.SELECT_ALL_PART_REQUESTS_DEFAULT_REQUEST_DATE
        });

export const updateSelectedPartRequestType = (requestType, isSelected) => ({
    isSelected,
    requestType,
    type: actions.UPDATE_ALL_PART_REQUESTS_SELECTED_REQUEST_TYPE
});



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/action-creators/facets.js